import { useState } from "react";
import { categories } from "@/mocks/home-data";
import SectionHeading from "./SectionHeading";

const toneStyle: Record<string, string> = {
  "实锤": "bg-primary-100 text-primary-700",
  "存疑": "bg-accent-100 text-accent-700",
  "后续": "bg-secondary-100 text-secondary-900",
  "起底": "bg-secondary-100 text-secondary-900",
  "对质": "bg-primary-100 text-primary-700",
  "反转": "bg-accent-100 text-accent-700",
  "盯帧": "bg-primary-100 text-primary-700",
  "串场": "bg-secondary-100 text-secondary-900",
  "幕后": "bg-accent-100 text-accent-700",
  "对比": "bg-primary-100 text-primary-700",
  "溯源": "bg-secondary-100 text-secondary-900",
  "代价": "bg-accent-100 text-accent-700",
  "实录": "bg-secondary-100 text-secondary-900",
  "断点": "bg-primary-100 text-primary-700",
  "催办": "bg-accent-100 text-accent-700",
  "开箱": "bg-primary-100 text-primary-700",
  "比例": "bg-secondary-100 text-secondary-900",
  "退路": "bg-accent-100 text-accent-700",
};

export default function LeidianModule() {
  const [activeKey, setActiveKey] = useState(categories[0].key);
  const active = categories.find((c) => c.key === activeKey) ?? categories[0];

  return (
    <section id="leidian" className="border-t border-background-200 bg-background-100/50 py-14 md:py-20">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <SectionHeading
          kicker="雷点整理 · 分类目录"
          title={<>雷点整理到频道里，想蹲哪类点哪类</>}
          desc="六类常客雷点分门别类摆好，每类都标注实锤、存疑与后续走向，翻完就知道坑藏在哪里。"
        />

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-12">
          {/* 左侧分类索引 */}
          <div className="lg:col-span-4">
            <div className="flex flex-col gap-1 rounded-lg border border-background-200 bg-background-50 p-2">
              {categories.map((c) => {
                const isActive = c.key === activeKey;
                return (
                  <button
                    key={c.key}
                    type="button"
                    onClick={() => setActiveKey(c.key)}
                    className={`flex items-center gap-3 rounded-md px-3 py-3 text-left transition-colors ${
                      isActive
                        ? "bg-primary-500 text-background-50"
                        : "text-foreground-700 hover:bg-background-100"
                    }`}
                  >
                    <span className={`font-label text-xs font-bold ${isActive ? "text-background-50/70" : "text-primary-500"}`}>
                      {c.index}
                    </span>
                    <span className="flex-1 font-label text-sm font-semibold">{c.tab}</span>
                    {isActive ? (
                      <i className="ri-arrow-right-s-line text-lg" />
                    ) : (
                      <i className="ri-arrow-right-up-line text-base text-secondary-500" />
                    )}
                  </button>
                );
              })}
            </div>
          </div>

          {/* 右侧选中分类详情 */}
          <div className="lg:col-span-8">
            <div className="flex flex-col gap-6 overflow-hidden rounded-lg border border-background-200 bg-background-50 p-4 md:flex-row md:p-0">
              <div className="relative md:w-2/5">
                <img
                  src={active.cover}
                  alt={active.tab}
                  title={active.tab}
                  className="h-48 w-full object-cover object-top md:h-full"
                />
                <span className="absolute left-3 top-3 rounded-md bg-background-50/90 px-2.5 py-1 font-label text-[11px] font-semibold text-primary-600">
                  #{active.tab}
                </span>
              </div>
              <div className="flex-1 py-1 md:p-6">
                <span className="font-label text-xs font-semibold uppercase tracking-[0.2em] text-accent-600">
                  {active.index} · 本期雷点目录
                </span>
                <h3 className="display-serif mt-2 text-xl font-black text-foreground-950 md:text-2xl">
                  {active.headline}
                </h3>
                <p className="mt-3 text-sm leading-7 text-foreground-600">{active.desc}</p>

                <div className="mt-5 flex flex-col gap-3">
                  {active.points.map((p) => (
                    <div key={p.text} className="flex items-start gap-3 border-l-2 border-background-200 pl-3">
                      <span
                        className={`mt-0.5 shrink-0 rounded-md px-2 py-0.5 font-label text-[11px] font-semibold ${
                          toneStyle[p.tag] ?? "bg-secondary-100 text-secondary-900"
                        }`}
                      >
                        {p.tag}
                      </span>
                      <p className="text-sm leading-6 text-foreground-700">{p.text}</p>
                    </div>
                  ))}
                </div>

                <a
                  href="#qingdan"
                  className="mt-5 inline-flex items-center gap-1.5 whitespace-nowrap font-label text-sm font-semibold text-primary-600 hover:text-primary-700"
                >
                  看看这类还有哪些瓜 <i className="ri-arrow-right-line" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}